import { useEffect, useState } from "react";
import { MenuItem, Select } from "@mui/material";

export default function TableSelectField({
  header,
  cell,
  updatedValue,
  disabled = false,
  isQC = false,
}: any) {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    if (cell) {
      isQC
        ? cell?.answers?.qc?.answer
          ? setValue(cell?.answers?.qc?.answer)
          : setValue(cell?.answers?.inspector?.answer || null)
        : setValue(cell?.answers?.inspector?.answer || null);
    }
  }, [cell]); // eslint-disable-line

  const onSingleSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setValue(value);
    updatedValue(value, cell?.id);
  };

  return (
    <Select
      sx={{ width: "100%", height: 40, padding: 1, my: 0.75 }}
      value={value || ""}
      onChange={(e: any) => onSingleSelectChange(e)}
      disabled={disabled}
    >
      {header?.answerOptions.map((opt: string) => (
        <MenuItem key={opt} value={opt}>
          {opt}
        </MenuItem>
      ))}
    </Select>
  );
}
